<template>
    <BaseTemplate app-name="Gestão de Ativos" page-title="">
        <template #content>
  <div class="container mx-auto px-4 py-4 md:py-8">
      <div class="flex flex-col  md:flex-row md:items-end md:justify-between gap-4 mb-6">
        <div class="flex flex-col sm:flex-row gap-2 w-full">
          <input v-model="localFilters.performed_by" type="text" placeholder="Filtrar por colaborador" class="w-full rounded-lg sm:w-48 px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
          <select v-model="localFilters.action" class="w-full rounded-lg sm:w-48 px-3 py-2 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
            <option value="">Todos os tipos</option>
            <option v-for="tipo in tiposAcoes" :key="tipo" :value="tipo">{{ tipo }}</option>
          </select>
        </div>
      </div>

      <!-- Tabela de Auditoria (Desktop) -->
      <div class="hidden md:block overflow-x-auto bg-white dark:bg-gray-800 rounded-lg shadow">
          <table class="min-w-full table-fixed divide-y divide-gray-200 dark:divide-gray-700">
              <thead class="bg-blue-500 dark:bg-blue-600 text-white dark:text-gray-300 text-sm uppercase tracking-wide">
                  <tr>
                      <th v-for="header in ['ID', 'tipo', 'Colaborador', 'Detalhes', 'Feito em']" :key="header" class="py-4 px-6 w-1/9 text-left">
                          {{ header }}
                      </th>
                  </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                  <tr v-for="auditoria in auditoria" :key="auditoria.id" class="hover:bg-gray-50 dark:hover:bg-gray-700">
                      <!-- Coluna ID / Kit Code -->
                      <td class="py-4 px-6 text-sm font-medium text-gray-900 dark:text-white">
                          {{ auditoria.id }}
                      </td>
                      <!-- Coluna Unidade -->
                      <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400 uppercase">
                          {{ auditoria.action || '-' }}
                      </td>
                      <!-- Coluna Criado Por -->
                      <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400 capitalize">
                          {{ auditoria.performed_by || '-' }}
                      </td>
                      <!-- Coluna Excluído Por -->
                      <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                          {{ auditoria.details || '-' }}
                      </td>
                      <!-- Coluna Movimentado Por -->
                      <td class="py-4 px-6 text-sm text-gray-500 dark:text-gray-400">
                          {{ formatarData(auditoria.timestamp) }}
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>

      <!-- Cards de Auditoria (Mobile) -->
      <div class="block md:hidden space-y-4">
          <div v-for="auditoria in auditoria" :key="auditoria.id" class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
              <!-- ID -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">ID:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400">{{ auditoria.id }}</span>
              </div>
              <!-- Tipo -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Tipo:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400 uppercase">{{ auditoria.action || '-' }}</span>
              </div>
              <!-- Colaborador -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Colaborador:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400 capitalize">{{ auditoria.performed_by || '-' }}</span>
              </div>
              <!-- Detalhes -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Detalhes:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400">{{ auditoria.details || '-' }}</span>
              </div>
              <!-- Feito em -->
              <div class="flex items-center space-x-2">
                  <span class="text-sm font-semibold text-gray-700 dark:text-gray-300">Feito em:</span>
                  <span class="text-sm text-gray-500 dark:text-gray-400">{{ formatarData(auditoria.timestamp) }}</span>
              </div>
          </div>
      </div>
    <!-- Paginação -->
    <div class="w-full mt-6">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <!-- Esquerda: Página e seletor -->
        <div class="flex flex-col md:flex-row md:items-center gap-2 w-full md:w-auto justify-center md:justify-start">
          <span class="text-sm text-gray-600 dark:text-gray-300 text-center md:text-left">Página {{ currentPage }} de {{ totalPages }}</span>
          <label class="flex items-center gap-2 justify-center md:justify-start">
            <span class="text-xs text-gray-500 dark:text-gray-400">Itens por página:</span>
            <select v-model.number="pageSize" @change="onPageSizeChange" class="w-28 px-2 py-1 border rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <option v-for="size in [10, 15, 25, 50, 100]" :key="size" :value="size">{{ size }}</option>
            </select>
          </label>
        </div>
        <!-- Direita: Botões de navegação -->
        <div class="flex gap-2 justify-center md:justify-end w-full md:w-auto">
          <button @click="prevPage" :disabled="currentPage === 1" class="px-4 py-2 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 hover:bg-blue-600 active:bg-blue-700 dark:hover:bg-blue-600 dark:active:bg-blue-800 disabled:opacity-50 transition-colors">Anterior</button>
          <button @click="nextPage" :disabled="currentPage === totalPages" class="px-4 py-2 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 hover:bg-blue-600 active:bg-blue-700 dark:hover:bg-blue-600 dark:active:bg-blue-800 disabled:opacity-50 transition-colors">Próxima</button>
        </div>
      </div>
    </div>
  </div>
        </template>
    </BaseTemplate>
</template>

<script setup>
import  BaseTemplate from '../templates/BaseTemplate.vue';
import { ref, watch, onMounted } from 'vue';
import apiClient from '@/services/authService';

const auditoria = ref([]);
const total = ref(0);
const totalPages = ref(1);
const pageSize = ref(15);

function onPageSizeChange() {
  currentPage.value = 1;
  fetchAuditoria();
}
const currentPage = ref(1);

const localFilters = ref({ kit_code: '', performed_by: '', action: '' });

async function fetchAuditoria() {
  try {
    const params = {
      page: currentPage.value,
      page_size: pageSize.value,
      kit_code: localFilters.value.kit_code || undefined,
      performed_by: localFilters.value.performed_by || undefined,
      action: localFilters.value.action || undefined,
    };
    const { data } = await apiClient.get('/api/v1/audit/', { params });
    auditoria.value = data.items || [];
    total.value = data.total || 0;
    totalPages.value = data.total_pages || 1;
    pageSize.value = data.page_size || 15;
    currentPage.value = data.page || 1;
  } catch (error) {
    auditoria.value = [];
    total.value = 0;
    totalPages.value = 1;
    console.error("Erro ao buscar auditoria:", error);
  }
}





const tiposAcoes = ref([]);

async function fetchTiposAcoes() {
  try {
    const { data } = await apiClient.get('/api/v1/audit/actions/');
    tiposAcoes.value = Array.isArray(data) ? data : [];
  } catch (error) {
    tiposAcoes.value = [];
    console.error('Erro ao buscar tipos de ação:', error);
  }
}

function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
    fetchAuditoria();
  }
}
function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--;
    fetchAuditoria();
  }
}

watch([() => localFilters.value.kit_code, () => localFilters.value.performed_by, () => localFilters.value.action], () => {
  currentPage.value = 1;
  fetchAuditoria();
});

const formatarData = (data) => {
    if (!data) return "Sem data";
    return new Date(data).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

onMounted(() => {
    fetchAuditoria();
    fetchTiposAcoes();
});
</script>